import styled from 'styled-components';
import TableRow from '@material-ui/core/TableRow';
import { Colors } from 'Constants';

export const StyledTableRow = styled(TableRow)`
  background-color: ${Colors['white']};
`;
